module.exports = __webpack_public_path__ + "static/10-7b6c1f30faf52e2f9f7a9d789ccf6360.jpg";